import { reactive, toRefs, ref } from 'vue'
import apiDevice from '../api/device.api'

const state = reactive({
  deviceList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiDevice.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useDevice() {

  const getDeviceList = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiDevice.getList(params)
    state.deviceList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 20

    state.loading = false
  }

  return {
    ...toRefs(state),
    getDeviceList
  }
}